import React from 'react';
import { Button, ButtonGroup } from 'reactstrap';
import { useTranslation } from 'react-i18next';

export const WEEKDAY_OPTIONS = [
    { value: 1, labelKey: 'schedulers.weekdays.monday', shortKey: 'schedulers.weekdays.mon' },
    { value: 2, labelKey: 'schedulers.weekdays.tuesday', shortKey: 'schedulers.weekdays.tue' },
    { value: 3, labelKey: 'schedulers.weekdays.wednesday', shortKey: 'schedulers.weekdays.wed' },
    { value: 4, labelKey: 'schedulers.weekdays.thursday', shortKey: 'schedulers.weekdays.thu' },
    { value: 5, labelKey: 'schedulers.weekdays.friday', shortKey: 'schedulers.weekdays.fri' },
    { value: 6, labelKey: 'schedulers.weekdays.saturday', shortKey: 'schedulers.weekdays.sat' },
    { value: 0, labelKey: 'schedulers.weekdays.sunday', shortKey: 'schedulers.weekdays.sun' },
];

const SendDaysSelector = ({ value = [], onChange, readOnly = false }) => {
    const { t } = useTranslation();
    const selectedDays = Array.isArray(value) ? value : [];

    const toggleDay = (dayValue) => {
        if (readOnly) return;
        const nextDays = selectedDays.includes(dayValue)
            ? selectedDays.filter((day) => day !== dayValue)
            : [...selectedDays, dayValue].sort((a, b) => a - b);
        onChange({ target: { value: nextDays } });
    };

    return (
        <ButtonGroup className="scheduler-weekdays">
            {WEEKDAY_OPTIONS.map((day) => {
                const isActive = selectedDays.includes(day.value);
                return (
                    <Button
                        key={day.value}
                        color={isActive ? 'primary' : 'secondary'}
                        outline={!isActive}
                        onClick={() => toggleDay(day.value)}
                        disabled={readOnly}
                        title={t(day.labelKey)}
                        style={{ minWidth: '2.75rem' }}
                    >
                        {t(day.shortKey)}
                    </Button>
                );
            })}
        </ButtonGroup>
    );
};

export default SendDaysSelector;
